import { cloneDeep } from "lodash";
import { newActions as actions } from "../actions";
import { initialState } from "../initialState";
import { createReducer, methodSwitcher } from "./utilities";

const { number } = initialState;

const clearCurrent = (state) => ({ ...state, current: {} });

const setNewList = (state, { data }) => {
   const newState = cloneDeep(state);
   newState.list = data;
   return newState;
};

const setCurrentNew = (state, { data }) => {
   const newState = cloneDeep(state);
   newState.current = { ...data.content, id: data.id };
   return newState;
};

const actionNew = (state, { data, id, method }) => {
   const newState = cloneDeep(state);
   methodSwitcher(newState, {
      ...data,
      content: {
         ...data
      }
   }, id, method);
   return newState;
};

export const newReducer = createReducer(number, {
   [actions.CLEAR_CURRENT]: clearCurrent,
   [actions.LIST]: setNewList,
   [actions.CURRENT]: setCurrentNew,
   [actions.CUD]: actionNew,
});
